import { Checkbox, Col, Form, FormInstance, Radio } from 'antd'

import { requiredRules } from 'src/app-constants'
import { useLocales } from 'src/locales'

type Props = {
  form: FormInstance
}

export const UrinarySymptomsCard = ({ form }: Props) => {
  const { t } = useLocales()

  const hasUrinary =
    Form.useWatch(['form', 'symptoms', 'urinaryDisorders', 'status'], form) ===
    'yes'

  return (
    <>
      <Col span={24}>
        <Form.Item
          name={['form', 'symptoms', 'urinaryDisorders', 'status']}
          rules={requiredRules}
          label={`7. ${t('epidemiology.urinary_disorders')}`}
        >
          <Radio.Group>
            <Radio value="dontKnow">{t('epidemiology.unknown')}</Radio>
            <Radio value="no">{t('common.no')}</Radio>
            <Radio value="yes">{t('common.yes')}</Radio>
          </Radio.Group>
        </Form.Item>
      </Col>

      {hasUrinary && (
        <>
          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'urinaryDisorders',
                'oliguriaAnuria',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>1. Oligurie / anurie</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'urinaryDisorders',
                'hyperchromicUrine',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>2. Urină hipercromă</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'urinaryDisorders',
                'hematuria',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>3. Hematurie</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'urinaryDisorders',
                'cloudyUrine',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>4. Urină tulbure</Checkbox>
            </Form.Item>
          </Col>

          <Col span={8}>
            <Form.Item
              name={[
                'form',
                'symptoms',
                'urinaryDisorders',
                'frequentMicturition',
                'isSelected'
              ]}
              valuePropName="checked"
            >
              <Checkbox>5. Micțiuni frecvente</Checkbox>
            </Form.Item>
          </Col>
        </>
      )}
    </>
  )
}
